import Moment from 'moment';

const digitsRE = /(\d{3})(?=\d)/g;

export default function brDate(value) {
  return Moment(value).format('DD/MM/YYYY HH:mm');
}

/**
 * 12345 => $12,345.00
 *
 * @param {String} currency
 * @param {Number} decimals Decimal places
 * @param {String} decimalPoint
 * @param {String} thousandSeparator
 */
export function currency(value, currency, decimals, decimalPoint = '.', thousandSeparator = ',') {
  value = parseFloat(value);
  if (!isFinite(value) || (!value && value !== 0)) return '';

  currency = currency != null ? currency : '$';
  let stringified = Math.abs(value).toFixed(decimals);
  stringified = stringified.replace('.', decimalPoint);
  const _int = stringified.slice(0, -1 - decimals);
  const i = _int.length % 3;
  const head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? thousandSeparator : ''))
    : '';
  const _float = stringified.slice(-1 - decimals);
  const sign = value < 0 ? '-' : '';
  return `${sign + currency} ${head
    }${_int.slice(i).replace(digitsRE, `$1${thousandSeparator}`)
    }${_float}`;
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

export function truncate(string, n, useWordBoundary) {
  if (string.length <= n) { return string; }
  const subString = string.substr(0, n - 1);
  return `${useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString}...`;
}
